import { Box } from "@mui/system";
import React from "react";
import flashappOveralIcon from "../../../../assests/Images/flasapp-hanging-iconY.png";

/**
 * Flash coin centered on the Roadmap → Tokenomics color seam.
 *
 * Desktop (≥1200px): a 40px black band sits above Tokenomics, so the visual
 * #181818 / black edge is 40px above this component — center the coin there.
 * Mobile / tablet: that band is hidden; center on the section boundary.
 */
export default function SectionDividerCoin() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "relative",
        height: 0,
        zIndex: 25,
        pointerEvents: "none",
        overflow: "visible",
      }}
    >
      <Box
        data-flash-seam-target="roadmap"
        data-flash-seam-roadmap
        sx={{
          position: "absolute",
          left: "50%",
          top: {
            xs: "0px",
            sm: "0px",
            md: "-8px",
            // 40px black band above tokenomics on lg+
            lg: "-40px",
          },
          transform: "translate(-50%, -50%)",
          width: {
            xs: "72px",
            sm: "86px",
            md: "100px",
            lg: "117px",
          },
          height: {
            xs: "72px",
            sm: "86px",
            md: "100px",
            lg: "117px",
          },
        }}
      >
        <img
          className="rotating roadmap-overlay"
          src={flashappOveralIcon}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            filter: "drop-shadow(0 0 18px rgba(251, 191, 4, 0.45))",
          }}
        />
      </Box>
    </Box>
  );
}
